import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandTimesheetCreateAddPage } from '../cabsand-timesheet-create-add/cabsand-timesheet-create-add';

@IonicPage()
@Component({
  selector: 'page-cabsand-timesheet-history',
  templateUrl: 'cabsand-timesheet-history.html',
})
export class CabsandTimesheetHistoryPage {
  timeSheetList: any = [];
  weeklySelectedDate = null;
  dateFilterList = [];
  actionAllowed:boolean = false;
  actiivityCodeList:any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getActivityCodeList();
    this.gettimeSheetList(null);
  }

  async getActivityCodeList() {
    this.actiivityCodeList = [];
    let formData: FormData = new FormData();
    formData.append("method_name","activity_code");
    return this.api.post("/tansix_prestart/Activity_code", false,formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          
          this.actiivityCodeList = result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  getCodeName(id){
    let code = "";
    let index = this.actiivityCodeList.findIndex(list_ => list_['id'] == id);
      if(index != -1){
        code = this.actiivityCodeList[index].code;
      }
    return code
  }


  async gettimeSheetList(filter) {
    this.timeSheetList = [];
    this.utiltiy.startLoading();
    let userId = await this.utiltiy.getStorage("userId");
    let formData: FormData = new FormData();
    // formData.append("user_id", userId);
    // formData.append("status", "2");
    formData.append("method_name", "history_list");
    if (filter) {
      formData.append("date_filter", filter);
    }
    this.api.post(`/tansix_prestart/timesheet/approver/Approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
        this.timeSheetList = result.result;
        if (result.result.length > 0) {
          const temp = result.extra_data.date_filter_list.filter(e => e != '');
          this.dateFilterList = temp;
        }
        else {
          this.utiltiy.toaster(result.message);
        }
        this.utiltiy.stopLoading();

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  searchByDate() {
    this.gettimeSheetList(this.weeklySelectedDate);
  }

  async acceptRecord(fuel) {
    if(!this.actionAllowed){
      return;
    }
    var options = {
      "title": '',
      "message": `Send for approval`,
      "approveText": 'Yes',
      "rejectText": 'No',
    }
    let status = await this.utiltiy.attentionDialog(options);
    if (status) {
      this.acceptTimesheet(fuel.id);
    }
    console.log("status", status);
  }

  async acceptTimesheet(id){
    let userId = await this.utiltiy.getStorage("userId");
    let formData: FormData = new FormData();
    formData.append("method_name", "approver_timesheet_reject_approve_update_status");
    // formData.append("user_id", userId);
    formData.append("timesheet_id", id);
    formData.append("status", '1');
    // timesheet/approver
    this.api.post(`/tansix_prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.searchByDate();

        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  formatAMPM(date) {
    date = date.split(":");
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }
  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deleteTimeSheet(id);
    }
    console.log("status", status);
  }

  deleteTimeSheet(id) {
    this.api.delete(`/tansix_prestart/timesheet/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.searchByDate();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }



  updateTimeSheet(prestart){
    this.navCtrl.push(CabsandTimesheetCreateAddPage, { param: prestart,copy:false });
  }
 
  copyTimeSheet(prestart){
   this.navCtrl.push(CabsandTimesheetCreateAddPage, { param: prestart,copy:true });
 }
 
async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-timesheet-create-rw");
 }

}




// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-history/cabsand-timesheet-history.ts